import React from "react";
import ReactGA from "react-ga4";
import { ApplicationContextProvider } from "components/ApplicationContextProvider";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import ApplicationShell from "./components/ApplicationShell";
import IndexScreen from "Screens/Index";
import DashboardScreen from "Screens/Dashboard";
import AuthorizeScreen from "Screens/Authorize";
import AppPage from "./Screens/AppPage";
// import ContentEditPage from "./Screens/ContentEditPage";
import ContentFinder from "./Screens/ContentFinder";
import HelpPortal from "components/ContextualHelp/HelpPortal";
import ArticlePage from "./Screens/Article";
import MediaPage from "./Screens/Media";
import PagePage from "./Screens/Page";
import RecentPage from "./Screens/Recent";
import SettingsPage from "./Screens/Settings";
import Dropzone from "./components/Overlays/Dropzone";
import GalleryPage from "./Screens/Gallery";
import ContainerScreen from "Screens/Container";
import ContainerEditScreen from "Screens/Container/EditScreen";
import TagScreen from "Screens/TagScreen";
import TagEditScreen from "Screens/TagScreen/Edit";
import AuditScreen from "Screens/AuditScreen";
import NotificationScreen from "Screens/NotificationScreen";
import AuthorScreen from "Screens/AuthorScreen";
import AuthorEditScreen from "Screens/AuthorScreen/Edit";
import EntryScreen from "Screens/CustomContentScreen";
import ChannelScreen from "Screens/CustomContentScreen/ChannelScreen";
import EntryEditScreen from "Screens/CustomContentScreen/EntryEditScreen";
import ChannelEditScreen from "Screens/CustomContentScreen/ChannelEditScreen";
import SettingPanelScreen from "Screens/CustomContentScreen/SettingPanelScreen";
import SearchScreen from "Screens/SearchScreen";
import PlannerScreen from "Screens/PlannerScreen";
import IssueScreen from "Screens/PlannerScreen/IssueScreen";
import IssueEditScreen from "Screens/PlannerScreen/IssueEditScreen";
import AssignmentEditScreen from "Screens/PlannerScreen/AssignmentEditScreen";
import AnalyticsScreen from "Screens/AnalyticsScreen";
import ScrollTop from "Screens/ScrollTop";
import AppShellErrorBoundary from "ErrorHandlers/AppShellErrorBoundary";
import ProtectedRouteErrorBoundary from "ErrorHandlers/ProtectedRouteErrorBoundary";

function App(props) {
    const [isInternalDrag, setIsInternalDrag] = React.useState(false);
    const [showDropzone, setShowDropzone] = React.useState(false);
    if (
        process.env.REACT_APP_GA_TRACKING_ID &&
        process.env.NODE_ENV === "production"
    ) {
        ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
    } else {
        console.info("GA tracking disabled");
    }
    return (
        <ApplicationContextProvider>
            <Router>
                <ScrollTop />
                <Switch>
                    <Route exact path="/" component={IndexScreen} />
                    <Route path="/authorize" component={AuthorizeScreen} />
                    <ProtectedRouteErrorBoundary>
                        <ProtectedRoute path="/app">
                            <AppShellErrorBoundary>
                                <ApplicationShell
                                    onDragStart={() => setIsInternalDrag(true)}
                                    onDragEnd={() => setIsInternalDrag(false)}
                                    onDragEnter={() => setShowDropzone(true)}
                                    requestShowDropzone={() =>
                                        setShowDropzone(true)
                                    }
                                >
                                    <Route
                                        path="/app/dashboard"
                                        component={DashboardScreen}
                                    />
                                    <Route
                                        path="/app/analytics"
                                        component={AnalyticsScreen}
                                    />
                                    <Route
                                        path="/app/recent"
                                        component={RecentPage}
                                    />
                                    <Route
                                        path="/app/content/:uuid"
                                        component={ArticlePage}
                                    />
                                    <Route
                                        path="/app/article/:uuid"
                                        component={ArticlePage}
                                    />
                                    <Route
                                        path="/app/page/:uuid"
                                        component={PagePage}
                                    />
                                    <Route
                                        path="/app/media/:uuid"
                                        component={MediaPage}
                                    />
                                    <Route
                                        path="/app/attachment/:uuid"
                                        component={ContentFinder}
                                    />
                                    <Route
                                        path="/app/gallery/:uuid"
                                        component={GalleryPage}
                                    />
                                    <Route
                                        path="/app/container"
                                        exact
                                        component={ContainerScreen}
                                    />
                                    <Route
                                        path="/app/container/:uuid"
                                        component={ContainerEditScreen}
                                    />
                                    <Route
                                        path="/app/tag"
                                        exact
                                        component={TagScreen}
                                    />
                                    <Route
                                        path="/app/tag/:uuid"
                                        component={TagEditScreen}
                                    />
                                    <Route
                                        path="/app/author"
                                        exact
                                        component={AuthorScreen}
                                    />
                                    <Route
                                        path="/app/author/:uuid"
                                        component={AuthorEditScreen}
                                    />
                                    <Route
                                        path="/app/settings/:setting?"
                                        component={SettingsPage}
                                    />
                                    <Route
                                        path="/app/audit/:thing?"
                                        component={AuditScreen}
                                    />
                                    <Route
                                        path="/app/notification"
                                        component={NotificationScreen}
                                    />
                                    <Route
                                        path="/app/custom-content"
                                        exact
                                        component={EntryScreen}
                                    />
                                    <Route
                                        path="/app/custom-content/channel"
                                        exact
                                        component={ChannelScreen}
                                    />
                                    <Route
                                        path="/app/custom-content/entry/:uuid"
                                        component={EntryEditScreen}
                                    />
                                    <Route
                                        path="/app/custom-content/channel/:uuid"
                                        component={ChannelEditScreen}
                                    />
                                    <Route
                                        path="/app/custom-content/setting/:uuid"
                                        component={SettingPanelScreen}
                                    />
                                    <Route
                                        path="/app/search"
                                        component={SearchScreen}
                                    />
                                    <Route
                                        path="/app/planner"
                                        exact
                                        component={PlannerScreen}
                                    />
                                    <Route
                                        path="/app/planner/issue"
                                        exact
                                        component={IssueScreen}
                                    />
                                    <Route
                                        path="/app/planner/issue/:uuid"
                                        component={IssueEditScreen}
                                    />
                                    <Route
                                        path="/app/planner/assignment/:uuid"
                                        component={AssignmentEditScreen}
                                    />
                                    <Route
                                        path="/app/p/:slug"
                                        component={AppPage}
                                    />
                                    <Dropzone
                                        isInternalDrag={isInternalDrag}
                                        showDropzone={showDropzone}
                                        onRequestClose={() =>
                                            setShowDropzone(false)
                                        }
                                    />
                                </ApplicationShell>
                            </AppShellErrorBoundary>
                        </ProtectedRoute>
                    </ProtectedRouteErrorBoundary>
                </Switch>
            </Router>
            <HelpPortal />
        </ApplicationContextProvider>
    );
}

export default App;
